export default {
  path: '/teacher',
  name: 'teacher',
  component: () => import(/* webpackChunkName: "teacher" */ '@/views/teacher/Index.vue'),
  children: [
    {
      path: '',
      redirect: 'login',
    },
    {
      path: 'login',
      name: 'login',
      component: () => import('@/views/teacher/Login.vue'),
    },
    {
      path: 'student-info',
      name: 'student-info',
      component: () => import('@/views/teacher/StudentInfo.vue'),
    },
  ],
};
